import React, { memo, useState } from 'react';
import { Handle, Position } from 'reactflow';
import cx from 'classnames';
import PlusIconComponent from './PlusIconComponent';
import * as styles from '../styles.module.css';
import NodeContent from '../Contents/NodeContent';
import { CHATBOT_OPTIONS_TYPE } from '../../../../constants/AppConstants';

const CustomNode = ({
  id, data, sourcePosition, targetPosition
}) => {
  // id -> Es el id del node
  const [isDropzoneActive, setDropzoneActive] = useState(false);

  const onDrop = () => {
    setDropzoneActive(false);
  };

  const onDragOver = (evt) => {
    evt.preventDefault();
  };

  const onDragEnter = () => {
    setDropzoneActive(true);
  };

  const onDragLeave = () => {
    setDropzoneActive(false);
  };

  const onClick = (e) => {
    e.stopPropagation();
    data.addNode(id, data);
  };

  const handleEditNode = (e) => {
    e.stopPropagation();
    data.editNode(id);
  };

  const handlePreviewBot = (e) => {
    e.stopPropagation();
    data.previewBot(id);
  };

  const handleRemoveNode = () => {
    data.removeNode(id, data);
  };

  const className = cx(styles.node, { [styles.nodeDropzone]: isDropzoneActive });

  const displayPlusIcon = () => {
    if ([
      CHATBOT_OPTIONS_TYPE.JUMP_TO,
      CHATBOT_OPTIONS_TYPE.ACTIVE_MIA,
      CHATBOT_OPTIONS_TYPE.RESOLVE_CHAT,
      CHATBOT_OPTIONS_TYPE.MENU,
      CHATBOT_OPTIONS_TYPE.WHATSAPP_FLOW,
      'decision',
      'menu'
    ].includes(data.option?.option_type)) return false;

    if (
      [CHATBOT_OPTIONS_TYPE.QUESTION, 'form', 'question'].includes(data.option?.option_type)
      && data.option?.fail_path_active
    ) {
      return false;
    }

    return true;
  };

  return (
    <>
      <div
        className={className}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
      >
        <Handle className={styles.handle} type="target" position={targetPosition || Position.Top} />
        <Handle className={styles.handle} type="source" position={sourcePosition || Position.Bottom} />
        <NodeContent
          nodeId={id}
          nodeData={data}
          editNode={handleEditNode}
          previewBot={handlePreviewBot}
          removeNode={handleRemoveNode}
        />
      </div>

      {displayPlusIcon() && (
        <PlusIconComponent onClick={onClick} />
      )}
    </>
  );
};

export default memo(CustomNode);
